/* Product page behaviours: Swiper gallery + scroll reveal + related products.
   Loaded only on product templates (see layout/theme.liquid).
   Depends on jQuery and the Swiper bundle, both loaded before this file. */
(function ($) {
  /* .reveal starts at opacity:0 (product.css) and only becomes visible
     once .visible is added. The observer now lives in assets/reveal.js
     (loaded on every template) — reuse it so late-injected nodes and the
     initial pass share one implementation. */
  var observeReveal = window.LavielaReveal || function ($els) {
    if ($els && $els.length) $els.addClass('visible');
  };

  function loadRecommendations() {
    $('.product-recommendations').each(function () {
      var $box = $(this);
      // When the S&D metafield rendered cards server-side, the box already
      // contains .autres-grid — don't clobber it with the native fetch.
      if ($box.find('.autres-grid').length) return;
      var url = $box.attr('data-url') +
        '?section_id=' + encodeURIComponent($box.attr('data-section-id')) +
        '&product_id=' + encodeURIComponent($box.attr('data-product-id')) +
        '&limit=' + encodeURIComponent($box.attr('data-limit')) +
        '&intent=related';

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) { return res.ok ? res.text() : ''; })
        .then(function (text) {
          if (!text) return;
          var html = document.createElement('div');
          html.innerHTML = text;
          var found = html.querySelector('.product-recommendations');
          if (!found || !found.innerHTML.trim()) return;
          $box.html(found.innerHTML);
          observeReveal($box.find('.reveal'));
        })
        .catch(function () { /* recommendations are optional — fail silently */ });
    });
  }

  $(function () {
    var $main = $('.swiper-main');
    var $thumbs = $('.galerie-mini .mini');

    if ($main.length && typeof Swiper !== 'undefined') {
      var main = new Swiper($main[0], {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: false,
        speed: 400
      });

      $thumbs.on('click', function () {
        var i = parseInt($(this).attr('data-index'), 10);
        main.slideTo(isNaN(i) ? 0 : i);
      });

      main.on('slideChange', function () {
        $thumbs.removeClass('actif').eq(main.activeIndex).addClass('actif');
      });

      // Source site drives object-fit via data-fit on the thumbnail button.
      // Slides are static, so set each slide's fit once at init (mirrors the
      // source's `v.style.objectFit = m.dataset.fit || 'cover'`).
      function applyFit(i) {
        var fit = $thumbs.eq(i).attr('data-fit');
        var img = $main.find('.swiper-slide').eq(i).find('img');
        img.css('objectFit', fit || 'cover');
        img.css('background', fit ? '#fff' : '');
      }
      $thumbs.each(function (i) { applyFit(i); });
    }

    observeReveal($('.reveal'));
    loadRecommendations();
  });
})(jQuery);
